import { request } from "@/libs/request/request"

export const createSession = (
  { appConfig }: { appConfig: { preset: string } & { [key: string]: unknown } },
  { signal }: { signal?: AbortSignal } = {},
) =>
  request(`${__API_URL__}/v1/create-upload-session`, {
    signal,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ appConfig }),
  }).then((res) => res.json() as Promise<{ id: string; iceServers: RTCIceServer[] }>)

export const setSessionOffer = (
  {
    id,
    offer,
    iceCandidates,
  }: { id: string; offer: RTCSessionDescriptionInit; iceCandidates: RTCIceCandidate[] },
  { signal }: { signal?: AbortSignal } = {},
) =>
  request(`${__API_URL__}/v1/set-session-offer?session=${id}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ offer, iceCandidates }),
    signal,
  })

export const waitSessionStart = (id: string, { signal }: { signal?: AbortSignal } = {}) =>
  request(`${__API_URL__}/v1/wait-upload-session-start?session=${id}`, { signal }).then(
    (res) =>
      res.json() as Promise<{
        answer: RTCSessionDescriptionInit
        iceCandidates: RTCIceCandidate[]
      }>,
  )

export const uploadSessionStarted = (id: string, { signal }: { signal?: AbortSignal } = {}) =>
  request(`${__API_URL__}/v1/upload-session-started?session=${id}`, { signal, method: "POST" })
